/**
 * Custom error for wrapping Captcha responses
 *
 * This error should be handled internally by the application, and not exposed to users
 */
export class DgCaptchaError extends Error {
  constructor(
    public showCaptcha: boolean,
    public validToken?: boolean,
    message = 'Should show captcha'
  ) {
    super(message);
    this.name = 'DgCaptchaError';
  }
}

// Type guard for checking errors
export function isDgCaptchaError(v: any): v is DgCaptchaError {
  return v.name === 'DgCaptchaError';
}
